import { TextField } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import styles from "./forgotchangepassword.module.css";
import Loader from "../../../admin/components/Loader";
import { Home } from "react-feather";

const ForgotChangePassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const { register, handleSubmit, control, watch, formState: { errors } } = useForm({
    mode: "onChange",
  });

  async function onSubmit(data) {
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");
    const postData = { ...data, token: localStorage.getItem("passwordToken") };

    return axios.post(process.env.REACT_APP_API_URL + "v1/forgot-password/reset", postData).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        const resData = response.data;
        setSuccessMsg(resData.message);
        localStorage.removeItem("passwordToken");
        localStorage.removeItem("passwordemail");
        setTimeout(() => {
          navigate("/sign-in");
        }, 3000);
      }
      if (response.data.status === "ERROR") {
        setErrorMsg(response?.data?.message);
      }
    }).catch((error) => {
      if (error && error?.response && error?.response?.data && error?.response?.data?.message) {
        setErrorMsg(error?.response?.data?.message);
      }
      setLoading(false);
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.LoginFormSec}`}>
        <div className={`${styles.LohinForm}`}>
          <Link to={"/"} className={`${styles.BackHomeBU}`}><Home />Back to home</Link>
          <h2 className={`${styles.BookingFormTitle} ${styles.Heading}`}>Reset Password</h2>
          <p className={`${styles.LoginformSmTitle}`}>Enter Your New Password</p>

          <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
            <p className={`${styles.SuccessM}`}>{successMsg}</p>
            <p className={`${styles.ErrorM}`}>{errorMsg}</p>
            <div className={`${styles.FormRow}`}>
              <div className={`${styles.FormGroup} FormGroup`}>
                <Controller
                  {...register("password", { required: "This field is Required" })}
                  control={control}
                  render={({ field }) => (<TextField {...field} label="Password*" variant="outlined" type="password" />)}
                />
                {errors.password && (<span className={`${styles.ErrorM}`}>{errors.password.message}</span>)}
              </div>
              <div className={`${styles.FormGroup} FormGroup`}>
                <Controller
                  {...register("password_confirmation", {
                    required: "This field is Required",
                    validate: (val) => {
                      if (watch("password") !== val) {
                        return "Your passwords do no match";
                      }
                    }
                  })}
                  control={control}
                  render={({ field }) => (<TextField {...field} id="outlined-basic" label="Confirm Password*" variant="outlined" type="password" />)}
                />
                {errors.password_confirmation && (<span className={`${styles.ErrorM}`}>{errors?.password_confirmation?.message}</span>)}
              </div>
              <Link to={"/sign-in"} className={`${styles.ForhotPassText}`}>Login</Link>
            </div>

            <button type="submit" className={`${styles.LoginBU}`}>
              <span>Change Password</span>
            </button>
          </form>
        </div>
      </div>

      <div className={`${styles.LoginBGSec}`}>
        <img src="/images/loginBG1.jpg" alt="" />
      </div>
    </div>
  </>);
};

export default ForgotChangePassword;